import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    name: 'fertilizers',
    path: '/fertilizers',
    component: () => import('../pages/FertilizerListPage.vue'),
    meta: {
      requiresAuth: true
    }
  }
];

export default routes;
